import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    height: 100%;
    padding: 10px;
    background-color: ${props => props.theme.backgroundColor};
}
`

export const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: auto;
    width: 550px;

    > button {
        margin-top: 10px;
    }
}
`

export const AudioContainer = styled.div`
    margin-left: 20px;
    height: 250px;
    position: relative;
    margin-top: 65px;
}
`

export const RowContainer = styled.div`
    display: flex;
    flex-direction: column;
}
`

export const ColumnContainer = styled.div`
    display: flex;
}
`
